import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps, normalizeClass as _normalizeClass } from "vue";
import MgMenuItem from './mg-menu-item.vue';
import MgMenuDividerItem from './mg-menu-divider-item.vue';
export default {
  __name: 'mg-sub-menu',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    open: {
      type: Boolean,
      default: false
    },
    popAlign: {
      type: String,
      default: 'right'
    }
  },
  emits: ['item-click', 'item-hover'],
  setup(__props, {
    emit: __emit
  }) {
    const emit = __emit;
    const handleItemClick = ({
      item,
      $event
    }) => {
      emit('item-click', {
        item,
        $event
      });
    };
    const handleItemHover = ({
      item,
      isHover,
      $event
    }) => {
      emit('item-hover', {
        item,
        isHover,
        $event
      });
    };
    const handleSubMouseenter = e => {
      e.stopPropagation();
    };
    const handleSubMouseleave = e => {
      e.stopPropagation();
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("ul", {
        class: _normalizeClass(['mg-sub-menu-wrapper', {
          'is--open': __props.open
        }, {
          'pop-align-left': __props.popAlign === 'left',
          'pop-align-right': __props.popAlign === 'right'
        }]),
        onMouseenter: handleSubMouseenter,
        onMouseleave: handleSubMouseleave
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, subIdx) => {
        return _renderSlot(_ctx.$slots, "default", {
          item: item,
          itemIndex: subIdx
        }, () => [item === '--' || item.title === '--' ? (_openBlock(), _createBlock(MgMenuDividerItem, {
          key: 0
        })) : (_openBlock(), _createBlock(MgMenuItem, _mergeProps({
          key: `sub_menu_item_${subIdx}`
        }, {
          ref_for: true
        }, item, {
          "pop-align": __props.popAlign,
          onHover: opts => handleItemHover({
            item,
            ...opts
          }),
          onItemHover: handleItemHover,
          onItemClick: handleItemClick,
          onClick: e => handleItemClick({
            item,
            $event: e
          })
        }), null, 16, ["pop-align", "onHover", "onClick"]))]);
      }), 256))], 34);
    };
  }
};